<template>
  <div class="box">
    <div class="Console">
      <!-- 气象控制 -->
      <div class="weatherNav">
        <div class="left mete">
          <div
            v-for="(item, index) in weatherNavLiat"
            :key="index"
            :class="activeIndex === index ? 'item activeW' : 'item'"
            @click.stop="toggleLayer(index, weatherNavLiatName[index])"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yunxiangMeteoDataHost } from "../../utils/config";
//变量
var drawParam_top = {}; //色斑图渲染参数
var drawWindData_top = []; //风数据
var i_now = null; //当前图层
let i_pre = null; //之前图层
var cloudImgList_top = {}; //卫星云图列表
var meteorologicalInfo = {};
var meteoInfoRequestUrl_top = null;
var timeSpanAll_top = 0; //时间轴时间跨度
var timeLineTimeList_top = new Array(); //时间轴所有时刻
var meteoTimeList_top = new Array(); //所有气象产品时刻
var meteoTimeList_minute_top = new Array(); //所有气象产品时刻

var currGlLayer = null; //雷达图层

var hov_arr = [];
var drag_arr = [];
var trans_arr = [];
var state_arr = [];
var tem_now = null; //高度
var time = null; //时间
var t_arr;
var h_arr;

var proInter; //设置定时器

//引入
import WindJSLeaflet from "../../assets/js/wind-js-leaflet/wind-js-leaflet.js";
import "../../assets/js/wind-js-leaflet/wind-js-leaflet.css";
import { Loading } from "element-ui";

import { mapGetters, mapActions, mapMutations } from "vuex";
import colors from "../../assets/js/colors";

export default {
  data() {
    return {
      meteorologicalFun: null,
      weatherNavLiat: [
        "雷达拼图",
        "预报反射率",
        "气温",
        "平均风",
        "阵风",
        "FY4-红外云图",
        "FY4-可见光云图",
        "葵花8-红外云图",
        "葵花8-可见光云图",
        "葵花8-大雾",
        "葵花8-深对流",
        "葵花8-沙尘",
        "葵花8-云层",
        "积冰",
        "颠簸",
        "风沙CAMS",
        "降水",
        "GEOS",
        "相对湿度",
      ],
      weatherNavLiatName: [
        "dbz",
        "DBZSWC",
        "temp",
        // "wind",
        "gust",
        "infImg",
        "visImg",
        "himawariInfImg",
        "himawariVisImg",
        "FOG",
        "DCC",
        "DSI",
        "IRT",
        "ic",
        "dutton",
        "cams",
        "rain",
        "fs",
        "rh",
      ],
      iEle: null,
      activeIndex: null,
      loadingInstance: null,
    };
  },
  computed: {
    ...mapGetters({
      cloudMap: "meteorologicalMap/cloudMap",
      meteoToken: "meteoToken",
    }),
  },
  watch: {
    wacth: {
      handler: function (val) {
        this.adsbMap.iconGroup.eachLayer((e) => {
          e.setIcon(this.createIcon(e.options.obj));
        });
      },
      deep: true,
    },
  },
  methods: {
    // 气象
    initMeteorologicalFun() {
      this.meteorologicalFun = {
        //time,iEle,altitude,areaCodeList
        add: (callback) => {
          var iEle = this.iEle;
          time = $(".i_drag").attr("t");

          // time = dateFormat("YYYYmmddHHMMSS", new Date());
          //若当前为地形图或雷达图,则使透明度为0.7
          let opacityEle = 1;
          if (this.currentMap == "dixing") {
            opacityEle = 0.7;
          }

          //取当前时间往前最近的一个有气象数据的时刻，且若所选时刻超出气象数据覆盖时间范围i时,默认取最大或最小时间
          var nearestTime = this.getMeteorologicalTime(time);

          time = nearestTime;
          //高亮当前时次
          if (iEle == "radarImg" || iEle == "dbz") {
            this.loadLaodStatus();
          }

          $(".i_avbl .timeScaleThisTime").css("background", "#fff910");
          $(".i_avbl .timeScaleThisTime-rt").css("background", "#0f51ff");
          $(".i_avbl .timeScaleThisTime[time=" + time + "]").css(
            "background",
            "#f50101"
          );

          //取消鼠标移动事件
          map.off("mousemove", map.meteoMouseMovefunc);

          //通过时间和高度获取要加载的产品类型
          let dataTypeByTime = meteorologicalInfo.timeList[time];
          let dataTypeByAltitude = meteorologicalInfo.altitudeList[tem_now];

          if (!dataTypeByTime) {
            this.loadingInstance.close();
            alert("无气象资料");
            return;
          }
          let intersection = dataTypeByTime.filter(function (val) {
            return dataTypeByAltitude.indexOf(val) > -1;
          });

          //北京时间转世界时间
          time = dateFormat("YYYYmmddHHMMSS", timeZoneFormat(time, -8));

          for (let k = 0; k < intersection.length; k++) {
            if (
              intersection[k] == "u" ||
              intersection[k] == "v" ||
              intersection[k] == "u10" ||
              intersection[k] == "v10"
            ) {
              continue;
            }

            let eleAreaCodeList =
              meteorologicalInfo.areaCodeList[intersection[k]];

            for (let p = 0; p < eleAreaCodeList.length; p++) {
              //判断文件类型
              var fileType = meteorologicalInfo.fileType.split(",")[0]; //文件类型
              var fileSuffix = "";
              if (meteorologicalInfo.fileType.split(",").length >= 2) {
                fileSuffix = meteorologicalInfo.fileType.split(",")[1];
              }

              let queryPath =
                yunxiangMeteoDataHost +
                "queryAreaData?" +
                "time=" +
                time +
                "" +
                "&bz2FileTime=" +
                meteorologicalInfo.timeMapping[time] +
                "" +
                "&altitude=" +
                tem_now +
                "" +
                "&dataType=" +
                intersection[k] +
                "" +
                "&areaCode=" +
                eleAreaCodeList[p] +
                "&fileType=" +
                fileType +
                "&suffix=" +
                fileSuffix;

              if (fileType == "binary") {
                setTimeout(() => {
                  if (typeof callback === "function") {
                    callback();
                  }
                  this.loadColorMap(queryPath, iEle, opacityEle);
                  this.loadMeteoMask(iEle);
                }, 500 * p);
              } else if (fileType == "image") {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", queryPath, true);

                xhr.setRequestHeader("Authorization", this.meteoToken);
                xhr.responseType = "blob";
                xhr.onload = (res) => {
                  if (res.currentTarget.status == 200) {
                    var blob = res.currentTarget.response;
                    var imgsrc = window.URL.createObjectURL(blob);

                    var imageBounds = [
                      [meteorologicalInfo.latMin, meteorologicalInfo.lngMin],
                      [meteorologicalInfo.latMax, meteorologicalInfo.lngMax],
                    ];

                    var image = new Image();
                    image.src = imgsrc;
                    image.onload = () => {
                      if (this.cloudMap.proGroup) {
                        this.cloudMap.proGroup.clearLayers();
                      }
                      //雷达通过i_now全局变量接收,以控制其透明度
                      if (iEle == "radarImg") {
                        i_now = L.imageOverlay(imgsrc, imageBounds, {
                          opacity: opacityEle,
                        }).addTo(this.cloudMap.proGroup);
                      } else {
                        L.imageOverlay(imgsrc, imageBounds, {
                          opacity: 1,
                        }).addTo(this.cloudMap.proGroup);
                      }
                    };
                    this.loadMeteoMask(iEle);
                    this.loadingInstance.close();
                  }
                };
                xhr.send();
              } else if (fileType == "webgl") {
                queryPath =
                  yunxiangMeteoDataHost +
                  "getMeteoAreaDataByImg?" +
                  "time=" +
                  time +
                  "" +
                  "&bz2FileTime=" +
                  meteorologicalInfo.timeMapping[time] +
                  "" +
                  "&altitude=" +
                  tem_now +
                  "" +
                  "&dataType=" +
                  intersection[k] +
                  "" +
                  "&areaCode=" +
                  eleAreaCodeList[p] +
                  "&fileType=" +
                  fileType +
                  "&suffix=" +
                  fileSuffix;

                if (meteorologicalInfo.preloadDatas) {
                  if (meteorologicalInfo.preloadDatas[time]) {
                    this.loadMeteoByImgWhenGl(
                      meteorologicalInfo.preloadDatas[time],
                      iEle
                    );
                    return;
                  }
                }

                var xhr = new XMLHttpRequest();
                xhr.open("GET", queryPath, true);

                xhr.setRequestHeader("Authorization", this.meteoToken);
                xhr.responseType = "blob";
                xhr.onload = (res) => {
                  if (res.currentTarget.status == 200) {
                    var blob = res.currentTarget.response;
                    var imgsrc = window.URL.createObjectURL(blob);

                    var imageBounds = [
                      [meteorologicalInfo.latMin, meteorologicalInfo.lngMin],
                      [meteorologicalInfo.latMax, meteorologicalInfo.lngMax],
                    ];
                    var img = new Image();
                    img.src = imgsrc;
                    img.onload = () => {
                      if (typeof callback === "function") {
                        callback();
                      }

                      if (!meteorologicalInfo.preloadDatas) {
                        meteorologicalInfo.preloadDatas = {};
                      }
                      meteorologicalInfo.preloadDatas[time] = img;

                      this.loadMeteoByImgWhenGl(img, iEle);
                      this.loadMeteoMask(iEle);
                      this.loadingInstance.close();
                    };
                  }
                };
                xhr.send();
              }

              drawWindData_top = []; //清空数据
              var tooltipWind = L.tooltip({ sticky: true, opacity: 0.5 });
              if (intersection[k] == "wspd") {
                let queryPathU =
                  yunxiangMeteoDataHost +
                  "queryAreaData?time=" +
                  time +
                  "&altitude=" +
                  tem_now +
                  "&dataType=u" +
                  "&areaCode=" +
                  eleAreaCodeList[p];
                let queryPathV =
                  yunxiangMeteoDataHost +
                  "queryAreaData?time=" +
                  time +
                  "&altitude=" +
                  tem_now +
                  "&dataType=v" +
                  "&areaCode=" +
                  eleAreaCodeList[p];

                //加载风流场
                //Promise.all([loadParticleAnimator(queryPathU,"u"), loadParticleAnimator(queryPathV,"v")]).then(function(values) {
                //    L.Layer.canvasLayer(drawParam_top, {density:2,galpha:0.8}).addTo(this.cloudMap.windGroup)
                //})

                Promise.all([
                  this.loadParticleAnimator(queryPathU, 2, 2),
                  this.loadParticleAnimator(queryPathV, 3, 2),
                ]).then((values) => {
                  this.loadingInstance.close();
                  WindJSLeaflet.init({
                    data: drawWindData_top,
                    localMode: true,
                    map: map,
                    //layerControl: layerControl,
                    useNearest: false,
                    timeISO: null,
                    nearestDaysLimit: 7,
                    displayValues: false,
                    displayOptions: {
                      displayPosition: "bottomleft",
                      displayEmptyString: "No wind data",
                    },
                    overlayName: "wind",

                    // https://github.com/danwild/wind-js-server
                    //pingUrl: 'http://localhost:7000/alive',
                    //latestUrl: 'http://localhost:7000/latest',
                    //nearestUrl: 'http://localhost:7000/nearest',
                    errorCallback: (e) => {
                      console.log(e);
                    },
                    mouseMoveFunc: (e) => {
                      var pos = WindJSLeaflet._map.containerPointToLatLng(
                        L.point(e.containerPoint.x, e.containerPoint.y)
                      );
                      var gridValue = WindJSLeaflet._windy.interpolatePoint(
                        pos.lng,
                        pos.lat
                      );

                      if (gridValue) {
                        var vMs = gridValue[1];
                        vMs = vMs > 0 ? (vMs = vMs - vMs * 2) : Math.abs(vMs);

                        var WindDirection = vectorToDegrees(gridValue[0], vMs);
                        var WindSpeed = vectorToSpeed(
                          gridValue[0],
                          vMs
                        ).toFixed(1);

                        tooltipWind
                          .setLatLng([pos.lat, pos.lng])
                          .setContent(
                            "<span><p>风速:" +
                              WindSpeed +
                              "m/s</p> <p>风向:" +
                              WindDirection +
                              "°</p></span>"
                          )
                          .addTo(this.cloudMap.windGroup);
                      } else {
                        tooltipWind.removeFrom(this.cloudMap.windGroup);
                      }
                    },
                  });

                  setTimeout(() => {
                    WindJSLeaflet._canvasLayer.addTo(this.cloudMap.windGroup);
                    WindJSLeaflet._canvasLayer._onLayerDidMove();
                  }, 100);
                });
              } else if (intersection[k] == "wspd10") {
                let queryPathU =
                  yunxiangMeteoDataHost +
                  "queryAreaData?time=" +
                  time +
                  "&altitude=" +
                  tem_now +
                  "&dataType=u10" +
                  "&areaCode=" +
                  eleAreaCodeList[p];
                let queryPathV =
                  yunxiangMeteoDataHost +
                  "queryAreaData?time=" +
                  time +
                  "&altitude=" +
                  tem_now +
                  "&dataType=v10" +
                  "&areaCode=" +
                  eleAreaCodeList[p];

                //加载风流场
                //Promise.all([loadParticleAnimator(queryPathU,"u"), loadParticleAnimator(queryPathV,"v")]).then(function(values) {
                //    L.Layer.canvasLayer(drawParam_top, {density:0.8,galpha:0.8}).addTo(this.cloudMap.windGroup)
                //})

                Promise.all([
                  this.loadParticleAnimator(queryPathU, 2, 2),
                  this.loadParticleAnimator(queryPathV, 3, 2),
                ]).then((values) => {
                  this.loadingInstance.close();
                  WindJSLeaflet.init({
                    data: drawWindData_top,
                    localMode: true,
                    map: map,
                    //layerControl: layerControl,
                    useNearest: false,
                    timeISO: null,
                    nearestDaysLimit: 7,
                    displayValues: false,
                    displayOptions: {
                      displayPosition: "bottomleft",
                      displayEmptyString: "No wind data",
                    },
                    overlayName: "wind",

                    // https://github.com/danwild/wind-js-server
                    //pingUrl: 'http://localhost:7000/alive',
                    //latestUrl: 'http://localhost:7000/latest',
                    //nearestUrl: 'http://localhost:7000/nearest',
                    errorCallback: (e) => {
                      console.log(e);
                    },

                    mouseMoveFunc: (e) => {
                      var pos = WindJSLeaflet._map.containerPointToLatLng(
                        L.point(e.containerPoint.x, e.containerPoint.y)
                      );
                      var gridValue = WindJSLeaflet._windy.interpolatePoint(
                        pos.lng,
                        pos.lat
                      );
                      if (gridValue) {
                        var vMs = gridValue[1];
                        vMs = vMs > 0 ? (vMs = vMs - vMs * 2) : Math.abs(vMs);

                        var WindDirection = vectorToDegrees(gridValue[0], vMs);
                        var WindSpeed = vectorToSpeed(
                          gridValue[0],
                          vMs
                        ).toFixed(1);

                        tooltipWind
                          .setLatLng([pos.lat, pos.lng])
                          .setContent(
                            "<span><p>风速:" +
                              WindSpeed +
                              "m/s</p> <p>风向:" +
                              WindDirection +
                              "°</p></span>"
                          )
                          .addTo(this.cloudMap.windGroup);
                      } else {
                        tooltipWind.removeFrom(this.cloudMap.windGroup);
                      }
                    },
                  });

                  setTimeout(() => {
                    WindJSLeaflet._canvasLayer.addTo(this.cloudMap.windGroup);
                    WindJSLeaflet._canvasLayer._onLayerDidMove();
                  }, 100);
                });
              }

              if (meteorologicalInfo.lngMax - meteorologicalInfo.lngMin <= 10) {
                var loadRange = L.polygon([
                  [
                    [meteorologicalInfo.latMin, meteorologicalInfo.lngMin],
                    [meteorologicalInfo.latMin, meteorologicalInfo.lngMax],
                    [meteorologicalInfo.latMax, meteorologicalInfo.lngMin],
                    [meteorologicalInfo.latMax, meteorologicalInfo.lngMax],
                  ],
                ]);
                if (
                  !map.getBounds().contains(loadRange.getBounds()) ||
                  map.getZoom() < 9
                ) {
                  map.flyToBounds(loadRange.getBounds());
                }
              }
            }
          }
        },
        del: () => {
          if (WindJSLeaflet) {
            WindJSLeaflet._destroyWind();
          }
          if (this.cloudMap.iconGroup) {
            this.cloudMap.iconGroup.clearLayers();
          }

          if (this.cloudMap.windGroup) {
            this.cloudMap.windGroup.clearLayers();
          }

          if (this.cloudMap.proGroup) {
            this.cloudMap.proGroup.clearLayers();
          }
        },
        update: () => {
          this.meteorologicalFun.add(() => {
            if (WindJSLeaflet) {
              WindJSLeaflet._destroyWind();
            }

            if (this.cloudMap.iconGroup) {
              this.cloudMap.iconGroup.clearLayers();
            }

            if (this.cloudMap.windGroup) {
              this.cloudMap.windGroup.clearLayers();
            }
          });
        },
      };
    },
    toggleLayer(index, item) {
      this.stop_p();
      if (this.activeIndex === index) {
        this.activeIndex = null;
        this.meteorologicalFun.del();
        map.off("mousemove", map.meteoMouseMovefunc);
        $(".i_fcst_tem").hide();
        $(".timer_box1").hide();
        return;
      }
      $(".meteoLegendBox").css("right", "5px");
      this.iEle = this.weatherNavLiatName[index];
      this.activeIndex = index;
      this.iEleName = item;
      this.add_time();
    },
    setAltitudeControll(altitudeArr, altitudeNow) {
      let unit = "hpa";
      let altitudeUnit = "米";
      h_arr = altitudeArr;
      tem_now = altitudeNow;
      t_arr = [];

      for (let s = 0; s < h_arr.length; s++) {
        if (h_arr[s] == "SFC") {
          t_arr[s] = "地面";
        } else {
          t_arr[s] =
            "<p>" +
            h_arr[s] +
            unit +
            "</p><p>" +
            hpa2Altitude(h_arr[s]) +
            altitudeUnit +
            "</p>";
        }
      }

      $(".t_drag").css({ top: 250 });
      $(".t_drag").html(t_arr[t_arr.length - 1]);

      if (h_arr.length > 0) {
        for (var i = 0; i < h_arr.length; i++) {
          if (altitudeNow != "SFC" && altitudeNow <= h_arr[i]) {
            var iH = parseInt($(".t_line").css("height"));
            var iL = h_arr.length;

            var iT = i * (iH / iL) - 10;

            $(".t_drag").css({ top: iT });
            $(".t_drag").html(t_arr[i]);
            tem_now = h_arr[i];

            i = h_arr.length;

            break;
          }
        }
        $(".i_fcst_tem").show();
      }

      this.initAltEvent();
    },
    initAltEvent() {
      $(".t_drag").off("mousedown");
      $(".t_drag").mousedown((e) => {
        e.stopPropagation();
        let iLe = t_arr.length;
        $(document).on("mousemove", (e) => {
          var iWi = e.pageY - $(".i_fcst_tem").offset().top;
          if (iWi > 0 && iWi < parseFloat($(".i_fcst_tem").css("height"))) {
            $(".t_drag").css({ top: iWi - 16 + "px" });
            var noe = t_arr[Math.floor(iWi / (270 / iLe))];
            $(".t_drag").html(noe);
          }
        });
        $(document).on("mouseup", (e) => {
          var iWi = e.pageY - $(".i_fcst_tem").offset().top;
          if (iWi < 0) {
            iWi = 0;
          } else if (iWi > 270) {
            iWi = 269;
          }
          tem_now = h_arr[Math.floor(iWi / (270 / iLe))];
          this.meteorologicalFun.del();
          this.meteorologicalFun.add();

          $(document).off("mousemove");
          $(document).off("mouseup");
        });
      });
    },
    add_time(dateQueryItemParam) {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.8)",
      });
      //判断查询起止时间
      let queryTimeFrom = "v1";

      let queryTimeTo = "";

      // hov_arr = [];
      // drag_arr = [];
      // trans_arr = [];
      // state_arr = [];
      var iEle = this.iEle;
      var str = "";

      if (
        iEle == "DCC" ||
        iEle == "DSI" ||
        iEle == "IRT" ||
        iEle == "FOG" ||
        iEle == "visImg" ||
        iEle == "infImg" ||
        iEle == "radarImg" ||
        iEle == "himawariVisImg" ||
        iEle == "himawariInfImg" ||
        iEle == "dbz" ||
        iEle == "mcappi"
      ) {
        queryTimeFrom = "d-0.125";
      }

      meteoInfoRequestUrl_top =
        yunxiangMeteoDataHost +
        "queryMeteorologicalInfo?dayBefore=" +
        queryTimeFrom +
        "&dayAfter=" +
        queryTimeTo +
        "&dataType=" +
        iEle;

      this.$axios({
        methods: "get",
        url: meteoInfoRequestUrl_top,
        headers: {
          Authorization: this.meteoToken,
        },
        async: true,
      }).then((data) => {
        this.loadMeteoAfterMeteoInfo(iEle, data.data);

        //自动开启气象数据更新检测
        // openMeteoTimeUpdate();
      });
      $("#meteoLegendName").html(this.iEleName + "：");
      $("#meteoLegendTable").show();
      renderLegend(iEle);
    },

    //设置初始数据
    loadMeteoAfterMeteoInfo(iEle, data) {
      //清空
      this.meteorologicalFun.del();
      $(".i_fcst_tem").hide();
      if (iEle != "radarImg" && iEle != "dbz") {
        // $("#radarStatusTextDiv").hide();
      }
      meteorologicalInfo = data.data;
      meteorologicalInfo.iEle = iEle;
      let SFC = "";

      //解析数据结果,获取高度集合及时间集合
      let altitudeList = new Array();
      for (let altitudeObjKey in data.data.altitudeList) {
        if (altitudeObjKey == "SFC") {
          SFC = "SFC";
        } else {
          altitudeList.push(altitudeObjKey);
        }
      }
      //若只为地面，则不加载高度切换控件
      if (altitudeList.length >= 1) {
        //高度列表数组转数字并排序
        altitudeList = altitudeList.map(Number);
        altitudeList.sort(function (a, b) {
          return a - b;
        });

        //加入SFC为地面高度
        if (SFC == "SFC") {
          altitudeList.splice(altitudeList.length, 0, "SFC");
        }

        let initAltitude = altitudeList[altitudeList.length - 1];

        this.setAltitudeControll(altitudeList, initAltitude);
      } else {
        tem_now = "SFC";
      }

      //时间转换为北京时间
      let ed8TimeList = {};
      for (let utcTime in meteorologicalInfo.timeList) {
        ed8TimeList[airTimeFormat(utcTime, "YYYYmmddHHMMSS")] =
          meteorologicalInfo.timeList[utcTime];
      }
      meteorologicalInfo.timeList = ed8TimeList;

      this.setTimeControll("ED8");

      //气象产品渲染
      this.meteorologicalFun.add();
    },
    //渲染色斑
    loadColorMap(PATH, ELE, opacityEle) {
      if (!opacityEle) {
        opacityEle = 1;
      }

      var xhr = new XMLHttpRequest();
      xhr.open("GET", PATH, true);

      xhr.setRequestHeader("Authorization", this.meteoToken);
      xhr.responseType = "arraybuffer";

      xhr.onload = (res) => {
        //二进制数据解压
        var binaryString = this.$pako.ungzip(res.currentTarget.response, {
          to: "string",
        });

        let objArray = binaryString.split(":::::");

        //数据请求结果
        let resultData = JSON.parse(objArray[0]);

        drawParam_top.interval_lat = resultData.resolution_lat; //空间分辨率
        drawParam_top.interval_lng = resultData.resolution_lng; //空间分辨率
        drawParam_top.latmax = resultData.latMax; //最大纬度
        drawParam_top.latmin = resultData.latMin; //最小纬度
        drawParam_top.lonmax = resultData.lngMax; //最大经度
        drawParam_top.lonmin = resultData.lngMin; //最小经度
        drawParam_top.nlat =
          (resultData.latMax - resultData.latMin) / resultData.resolution_lat;
        drawParam_top.nlon =
          (resultData.lngMax - resultData.lngMin) / resultData.resolution_lng;
        objArray[1] = objArray[1].replace(/nan/g, "0");
        let o = JSON.parse(objArray[1]); //数值

        for (var i = 0; i < o.length; i++) {
          for (var j = 0; j < o[i].length; j++) {
            if (ELE == "dew2") {
              o[i][j] = o[i][j] - 273.15;
            }
          }
        }

        drawParam_top.ele = ELE;
        drawParam_top.data = o;

        var rgba = colors[ELE];

        setTimeout(() => {
          if (i_pre) {
            if (this.cloudMap.proGroup.hasLayer(i_pre)) {
              this.cloudMap.proGroup.removeLayer(i_pre);
            }
          }
        }, 90);

        i_pre = i_now;

        var opacityThreshold = null;
        if (ELE == "rain") {
          opacityThreshold = 1.2;
        } else if (ELE == "vis") {
          opacityThreshold = -6;
        }
        i_now = L.tileLayer
          .drawImg(drawParam_top, {
            color: rgba, //阈值，必传参数
            tile_size: 129, //设置渲染分辨率，越大越清晰
            gradient: 0.25, //设置渐变度，越小渐变越小,最大0.5,0.25是完全渐变
            opacity: opacityEle,
            pane: "radar",
            noWrap: false,
            map: map,
            opacityThreshold: opacityThreshold,
          })
          .addTo(this.cloudMap.proGroup);
        if (ELE === "wind") {
          return;
        }
        this.loadingInstance.close();
      };

      xhr.send();
    },

    loadParticleAnimator(url, number, category) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);

        xhr.setRequestHeader("Authorization", this.meteoToken);
        xhr.responseType = "arraybuffer";
        xhr.onload = (res) => {
          var binaryString = this.$pako.ungzip(res.currentTarget.response, {
            to: "string",
          });

          let objArray = binaryString.split(":::::");

          //数据请求结果
          let resultData = JSON.parse(objArray[0]);

          let drawParam = {};
          var header = {};

          header.dy = resultData.resolution_lat; //空间分辨率
          header.dx = resultData.resolution_lng; //空间分辨率
          header.la1 = resultData.latMax; //最大纬度
          header.la2 = resultData.latMin; //最小纬度
          header.lo2 = resultData.lngMax; //最大经度
          header.lo1 = resultData.lngMin; //最小经度
          header.ny = (header.la1 - header.la2) / resultData.resolution_lat + 1;
          header.nx = (header.lo2 - header.lo1) / resultData.resolution_lng + 1;
          header.parameterCategory = category;
          header.parameterNumber = number;
          header.numberPoints = header.nx * header.ny;

          var dateStr = objArray[1];
          var newDataStr = dateStr.replace(/\[|]/g, "");
          drawParam.data = newDataStr.split(",");
          drawParam.header = header;
          drawWindData_top.push(drawParam);
          resolve("success");
        };
        xhr.send();
      });
    },
    /**
     * 设置并显示时间控件
     */

    setTimeControll(timeZone) {
      if (!meteorologicalInfo.timeList) {
        return;
      }

      //时间轴距离容器左边距
      var timelineMarginLeft = parseInt(
        $(".i_line").css("marginLeft").replace("px", "")
      );

      //转数字并排序
      timeLineTimeList_top = new Array();
      meteoTimeList_top = new Array();
      meteoTimeList_minute_top = new Array();
      for (let timeObjKey in meteorologicalInfo.timeList) {
        meteoTimeList_top.push(timeObjKey);
        meteoTimeList_minute_top.push(
          timeObjKey.substring(0, timeObjKey.length - 2) + "00"
        );

        //取到小时
        let timeToHour = timeObjKey.substring(0, 10);

        if (timeLineTimeList_top.indexOf(timeToHour) == -1) {
          timeLineTimeList_top.push(timeToHour);
        }
      }

      //排序
      meteoTimeList_top = meteoTimeList_top.map(Number);
      meteoTimeList_top.sort(function (a, b) {
        return a - b;
      });
      meteoTimeList_minute_top = meteoTimeList_minute_top.map(Number);
      meteoTimeList_minute_top.sort(function (a, b) {
        return a - b;
      });

      timeLineTimeList_top = timeLineTimeList_top.map(Number);
      timeLineTimeList_top.sort(function (a, b) {
        return a - b;
      });

      //获取两个时间间隔之间连续的小时数
      let timestampSpan =
        airTimeFormat(
          timeLineTimeList_top[timeLineTimeList_top.length - 1],
          null,
          timeZone
        ).getTime() -
        airTimeFormat(timeLineTimeList_top[0], null, timeZone).getTime();
      let timeListPerHour = [];
      for (let s = 0; s < timestampSpan / (1000 * 60 * 60) + 2; s++) {
        timeListPerHour[s] = dateFormat(
          "YYYYmmddHHMMSS",
          new Date(
            airTimeFormat(timeLineTimeList_top[0], null, timeZone).getTime() +
              s * 1000 * 60 * 60
          )
        );
      }

      timeLineTimeList_top = timeListPerHour;
      if (timeLineTimeList_top.length > 0) {
        let timeInterval =
          parseInt(timeLineTimeList_top.length / 8) == 0
            ? 1
            : parseInt(timeLineTimeList_top.length / 8);
        let stop = false;
        let str = "";

        let widthPeSpan =
          (100 / (timeLineTimeList_top.length - 1)) * timeInterval;

        for (var i = 0; i < timeLineTimeList_top.length; i++) {
          if ((i + 1) * timeInterval < timeLineTimeList_top.length) {
            let date = dateFormat(
              "dd-HH:MM",
              airTimeFormat(
                timeLineTimeList_top[i * timeInterval] + "",
                null,
                timeZone
              )
            );
            str +=
              '<span style="text-align:left;width: ' +
              widthPeSpan +
              '%" name="' +
              timeLineTimeList_top[timeLineTimeList_top.length - 1] +
              '">' +
              date.split("-")[0] +
              "日" +
              date.split("-")[1] +
              "</span>";
          }

          let date2 = dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            airTimeFormat(timeLineTimeList_top[i] + "", null, timeZone)
          );
          hov_arr.push(date2);
          drag_arr.push(date2);
          trans_arr.push(timeLineTimeList_top[i]);
        }

        let date1 = dateFormat(
          "dd-HH:MM",
          airTimeFormat(
            timeLineTimeList_top[timeLineTimeList_top.length - 1] + "",
            null,
            timeZone
          )
        );
        str +=
          '<span style="text-align:right;width:100px;position: absolute;right: -66px;" name="' +
          timeLineTimeList_top[timeLineTimeList_top.length - 1] +
          '">' +
          date1.split("-")[0] +
          "日" +
          date1.split("-")[1] +
          "</span>";

        //时间轴时间跨度
        timeSpanAll_top =
          airTimeFormat(
            timeLineTimeList_top[timeLineTimeList_top.length - 1],
            null,
            timeZone
          ).getTime() -
          airTimeFormat(timeLineTimeList_top[0], null, timeZone).getTime();
        //获取控件长度
        $(".timer_box1").css("opacity", 0);
        $(".timer_box1").show();

        let timeControlLength = $(".i_line").width();
        $(".timer_box1").hide();
        $(".timer_box1").css("opacity", 1);

        if ($(".i_avbl").children(".timeScaleThisTime")) {
          $(".i_avbl").children(".timeScaleThisTime").remove();
        }
        //气象产品时间在时间轴上的位置标识
        for (let time in meteorologicalInfo.timeList) {
          //将时间字符串转换为北京时间时间戳以计算刻度距离最左边的百分比
          let timeSpanThisTime =
            airTimeFormat(time, null, timeZone).getTime() -
            airTimeFormat(timeLineTimeList_top[0], null, timeZone).getTime();
          let marginLeft =
            (timeSpanThisTime / timeSpanAll_top) * timeControlLength +
            timelineMarginLeft;

          let timeScaleHtml =
            "<div onmouse class='timeScaleThisTime' time='" +
            time +
            "' style='position: absolute;" +
            "left: " +
            marginLeft +
            "px;" +
            "height:9px;" +
            "width: 3px;" +
            "top:12px;" +
            "background: #fff910;" +
            "border-radius:4px;" +
            "display: inline-block;" +
            "'></div>";

          var tmpTimek = airTimeFormat(time, "", "ED8");

          if (
            meteorologicalInfo.realTimeListDict.indexOf(
              moment(tmpTimek).utc().format("YYYYMMDDHHmmss")
            ) != -1
          ) {
            timeScaleHtml =
              "<div onmouse class='timeScaleThisTime timeScaleThisTime-rt' time='" +
              time +
              "' style='position: absolute;" +
              "left: " +
              marginLeft +
              "px;" +
              "height:9px;" +
              "width: 3px;" +
              "top:12px;" +
              "background: #0f51ff;" +
              "border-radius:4px;" +
              "display: inline-block;" +
              "'></div>";
          }

          $(".i_avbl").append(timeScaleHtml);
        }
        $(".timer_box1").show();
        $(".i_tline").html(str);
        $(".i_drag").attr("st", meteoTimeList_top);

        //获取当前时间,若时间轴时间包含当前时间,则将时间轴定位到当前时间
        var nowDateFormated = dateFormat("YYYYmmddHHMMSS", new Date());

        //若当前时间轴已经设置了事件属性,则取其原有时间进行显示
        if ($(".timer_box1 .i_drag").attr("t")) {
          nowDateFormated = $(".timer_box1 .i_drag").attr("t");
        }
        this.re_drag(nowDateFormated);
        this.set_click();
      }
    },
    set_click() {
      $(".i_line")
        .off("click")
        .click((e) => {
          this.meteoTimelineDragOrClick(e, "click");
        });
    },
    meteoTimelineDragOrClick(e, mousetype) {
      if ($("#airTimeSpanControlDIV").length >= 1) {
        if (
          e.offsetX >= $("#airTimeSpanControlDIV").position().left &&
          e.offsetX <=
            $("#airTimeSpanControlDIV").position().left +
              $("#airTimeSpanControlDIV").width()
        ) {
          isPlayedAirAnimation_top = true;
        }
      }

      var iWi = e.pageX - $(".i_line").offset().left;
      var iW = parseFloat($(".i_line").css("width"));
      var iL = drag_arr.length;

      if ("click" == mousetype) {
        $(".i_drag").css("left", iWi - 43 + "px");
        $(".i_played").css("width", iWi + "px");
      }

      let mouseMarginLeft = $(".i_drag").position().left + 43;
      let mouseMarginLeftPer = mouseMarginLeft / $(".i_avbl").width();
      let mouseMarginLeftTimestampDiff = mouseMarginLeftPer * timeSpanAll_top;
      let mouseMarginLeftTimestamp =
        airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime() +
        mouseMarginLeftTimestampDiff;
      let timeStr = dateFormat(
        "mm-dd HH:MM:SS",
        new Date(mouseMarginLeftTimestamp)
      );

      $(".i_drag").html(timeStr);

      var i = Math.floor(iWi / (iW / iL));
      var noe = drag_arr[i];
      var not = trans_arr[i];
      var nos = state_arr[i];
      $(".i_drag").attr(
        "t",
        dateFormat("YYYYmmddHHMMSS", new Date(mouseMarginLeftTimestamp))
      );
      $(".i_drag").attr("i", i);
      $(".i_drag").attr("state", nos);

      this.meteorologicalFun.update();
    },
    /**
     *
     * @param i
     * 设置时间轴当前时间
     */
    re_drag(time) {
      var iW = parseFloat($(".i_avbl").css("width"));
      //计算时间轴状态
      let timeParamTime = airTimeFormat(time, null, "ED8");

      //最大最小时间判断修正，不能大于时间轴最大时间，不能小于时间轴最小时间
      let maxTime = airTimeFormat(
        timeLineTimeList_top[timeLineTimeList_top.length - 1],
        null,
        "ED8"
      );
      let minTime = airTimeFormat(timeLineTimeList_top[0], null, "ED8");

      if (timeParamTime > maxTime) {
        timeParamTime = maxTime;
      } else if (timeParamTime < minTime) {
        timeParamTime = minTime;
      }

      let lengthPer =
        (timeParamTime.getTime() -
          airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime()) /
        timeSpanAll_top;
      let playedLength = lengthPer * iW;

      //设置时间显示文本
      let timeStr = dateFormat("YYYY-mm-dd HH:MM:SS", timeParamTime);
      $(".i_drag").html(timeStr);

      //最大最小时间判断修正后的时间
      let timeModify = dateFormat("YYYYmmddHHMMSS", timeParamTime);
      $(".i_drag").attr("t", timeModify);
      //$('.i_drag').attr('state',state_arr[i]);

      $(".i_drag").css("left", playedLength - 43 + "px");
      $(".i_played").css("width", playedLength + "px");
    },

    to_play() {
      var that = this;
      $("#to_play_meteo").click(function () {
        if ($(this).attr("src") == "image/start.png") {
          $(this).attr("src", "image/stop.png");
          $(this).css("backgroundImage", "url(image/stop.png)");
          that.set_p();
        } else {
          $(this).attr("src", "image/start.png");
          $(this).css("backgroundImage", "url(image/start.png)");
          that.stop_p();
        }
      });

      $(".i_line")
        .off("mouseover")
        .mouseover(function (e) {
          //当鼠标指针从元素上移入时
          //计算显示时间

          let mouseMarginLeft = e.pageX - 180;
          let mouseMarginLeftPer = mouseMarginLeft / $(".i_avbl").width();
          let mouseMarginLeftTimestampDiff =
            mouseMarginLeftPer * timeSpanAll_top;
          let mouseMarginLeftTimestamp =
            airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime() +
            mouseMarginLeftTimestampDiff;
          let timeStr = dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            new Date(mouseMarginLeftTimestamp)
          );

          var iW = parseFloat($(".i_line").css("width"));
          var iL = hov_arr.length;
          var noe = hov_arr[Math.floor(e.offsetX / (iW / iL))];
          $("#tooltip2").html(timeStr);
          $("#tooltip2")
            .css({ left: e.pageX - 200 + "px" })
            .show();
        })
        .off("mouseout")
        .mouseout(function () {
          $("#tooltip2").hide();
        })
        .off("mousemove")
        .mousemove(function (e) {
          //计算显示时间
          let mouseMarginLeft = e.pageX - 180;
          let mouseMarginLeftPer = mouseMarginLeft / $(".i_avbl").width();
          let mouseMarginLeftTimestampDiff =
            mouseMarginLeftPer * timeSpanAll_top;
          let mouseMarginLeftTimestamp =
            airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime() +
            mouseMarginLeftTimestampDiff;
          let timeStr = dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            new Date(mouseMarginLeftTimestamp)
          );

          var iW = parseFloat($(".i_line").css("width"));
          var iL = hov_arr.length;
          var noe = hov_arr[Math.floor(e.offsetX / (iW / iL))];
          $("#tooltip2").html(timeStr);
          $("#tooltip2").css({ left: e.pageX - 200 + "px" });
        });
    },
    set_p() {
      let time = $(".i_drag").attr("t");

      //播放：每100毫秒移动一次，每次移动代表五分钟数据
      let timestampPlayed = airTimeFormat(time, null, "ED8").getTime();

      proInter = setInterval(() => {
        // if(i == meteoTimeList_top.length-1){
        //     i = 0;
        // }else{
        //     i += 1;
        // }
        var iW = parseFloat($(".i_line").css("width"));

        time = dateFormat("YYYYmmddHHMMSS", new Date(timestampPlayed));
        $(".i_drag").attr("t", time);
        //根据当前时间算出长度百分比
        let timeParamTime = airTimeFormat(time, null, "ED8");
        let lengthPer =
          (timeParamTime.getTime() -
            airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime()) /
          timeSpanAll_top;
        let playedLength = lengthPer * iW;

        $(".i_drag").animate({ left: playedLength - 43 + "px" }, 8);
        $(".i_played").animate({ width: playedLength + "px" }, 8);

        let mouseMarginLeftTimestampDiff = lengthPer * timeSpanAll_top;
        let mouseMarginLeftTimestamp =
          airTimeFormat(timeLineTimeList_top[0], null, "ED8").getTime() +
          mouseMarginLeftTimestampDiff;
        let timeStr = dateFormat(
          "mm-dd HH:MM:SS",
          new Date(mouseMarginLeftTimestamp)
        );
        $(".i_drag").html(timeStr);
        if (meteoTimeList_top.indexOf(parseInt(time)) != -1) {
          $(".i_drag").attr("t", time);
          this.meteorologicalFun.update();
        }

        if (time > timeLineTimeList_top[timeLineTimeList_top.length - 1]) {
          timestampPlayed = airTimeFormat(
            timeLineTimeList_top[0],
            null,
            "ED8"
          ).getTime();
        }

        let airPlayRatio = 0;
        if (meteorologicalInfo.timeSpan == 60) {
          timestampPlayed += 1000 * 60 * 3;
          timestampPlayed =
            timestampPlayed - (timestampPlayed % (1000 * 60 * 3));

          airPlayRatio = (3 * 60 * 1000) / 50;
        } else if (meteorologicalInfo.timeSpan == 180) {
          timestampPlayed += 1000 * 60 * 6;
          timestampPlayed =
            timestampPlayed - (timestampPlayed % (1000 * 60 * 6));

          airPlayRatio = (6 * 60 * 1000) / 50;
        } else {
          timestampPlayed += 1000 * 60;
          timestampPlayed = timestampPlayed - (timestampPlayed % (1000 * 60));

          airPlayRatio = (60 * 1000) / 50;
        }
      }, 50);
    },
    stop_p() {
      clearInterval(proInter);
    },
    /**
     *根据任意时间获取离其最近的气象产品时次
     */
    getMeteorologicalTime(time) {
      var currentTimeStr = "";
      if (time <= meteoTimeList_top[0]) {
        currentTimeStr = meteoTimeList_top[0];
      } else if (time >= meteoTimeList_top[meteoTimeList_top.length - 1]) {
        currentTimeStr = meteoTimeList_top[meteoTimeList_top.length - 1];
      } else {
        for (let k = 0; k < meteoTimeList_top.length; k++) {
          if (time - meteoTimeList_top[k] < 0) {
            currentTimeStr = meteoTimeList_top[k - 1];
            break;
          } else if (time - meteoTimeList_top[k] == 0) {
            currentTimeStr = meteoTimeList_top[k];
            break;
          }
        }
      }

      return currentTimeStr;
    },

    //获取雷达工作状态
    loadLaodStatus() {
      this.$axios({
        url: yunxiangMeteoDataHost + "getRadarStatus",
        headers: {
          Authorization: this.meteoToken,
        },
        methods: "get",
      }).then((data) => {
        data = data.data;
        data = JSON.parse(data.data);
        var workingNum = 0;
        var cloesedNum = 0;

        data.forEach(function (item, index) {
          if (item.status == true) {
            workingNum++;
          } else {
            cloesedNum++;
          }
        });
        console.log(workingNum, cloesedNum);
      });
    },

    //渲染雷达图
    loadMeteoByImgWhenGl(img, iEle) {
      var colorMap = getColorRamp(glColor.dbz);

      setTimeout(() => {
        if (i_pre) {
          if (this.cloudMap.proGroup.hasLayer(i_pre)) {
            this.cloudMap.proGroup.removeLayer(i_pre);
          }
        }
      }, 10);

      var ofs4 = fragmentShaders[iEle];

      i_pre = currGlLayer;
      currGlLayer = L.imageOverlay
        .arrugator(
          [img.src],
          //["../../dbz_20211111043000_SFC_8_0.01.png","../../dbz_20211111043000_SFC_8_0.01.png","../../dbz_20211111043000_SFC_8_0.01.png"],
          {
            // The "controlPoints" option must be an array of arrays of numbers, containing
            // the coordinates in the source CRS of the four corners of the image, as follows:
            controlPoints: [
              [73.0, 12.21], // bottom-left
              [73.0, 54.2], // top-left
              [134.99, 12.21], // lower-right
              [134.99, 54.2], // upper-right
            ],
            epsilon: 10000,
            // The "projector" option must be a forward-projection function.
            // Leveraging proj4 as follows is recommended.
            // It's up to the developer to ensure that the destination projection matches the Leaflet display CRS.
            projector: proj4("EPSG:4326", "EPSG:3857").forward,
            colorMap: colorMap,
            fragmentShader: ofs4,
            pane: "radar",
            attribution:
              "<a href='https://kartkatalog.geonorge.no/metadata/n5000-raster/7e1b827e-3ccd-48a8-91ce-cc8125d6e4c1'>N5000 by Kartverket</a>",
          }
        )
        .addTo(this.cloudMap.proGroup);
      this.loadingInstance.close();
    },

    loadMeteoMask(iEle) {
      if (mask_top[iEle]) {
        L.geoJson(mask_top[iEle], {
          color: "rgba(0,0,0,0)",
          fillOpacity: 0.6,
          fillColor: "white",
          pane: "ypane",
        }).addTo(this.cloudMap.proGroup);
      }
    },
  },

  mounted() {
    this.initMeteorologicalFun();
    this.to_play();
  },
  beforeDestroy() {
    this.stop_p();
  },
};
</script>


<style lang="less" scoped>
.my-div-icon {
  background: none !important;
}

.activeW {
  color: #d49500;
}

.Console {
  position: absolute;
  bottom: -292px;
  margin-top: 10px;
}

.box {
  position: absolute;
  right: 0;
  z-index: 2;

  .item {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .item:hover {
    color: #d49500;
  }
  .layerItem {
    border-radius: 50%;
  }
  .layerItem:hover {
    background-color: #d39500;
  }
  .weatherNav {
    .left {
      float: left;
      width: 120px;
      color: #c3d3ea;
      background: linear-gradient(
        0deg,
        rgba(27, 50, 81, 0.88) 0%,
        rgba(28, 44, 59, 0.88) 99%
      );
    }
  }
}
</style>